import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomePage } from "./pages/home/home.page";
import { AuthGuard } from "./guards/auth.guard";
import { AttachmentPage } from "./pages/attachments/attachment/attachment.page";
import { RanchHomePage } from './pages/ranches/ranch-home/ranch-home.page';
import { PartnerLoginPage } from "./pages/partner-login/partner-login.page";
import { MainLayoutComponent } from "./main-layout.component";

const routes: Routes = [
  {
    path: 'partner-login', component: PartnerLoginPage
  },
  {
    path: '',
    loadChildren: () => import('./pages/public/public.module').then(m => m.PublicModule),
  },
  {
    path: 'private',
    component: MainLayoutComponent,
    children: [
      {path: '', redirectTo: 'home', pathMatch: 'prefix'},
      {path: 'home', component: HomePage, canActivate: [AuthGuard]},
      {path: 'attachments', component: AttachmentPage, canActivate: [AuthGuard]},
      {path: 'ranches', component: RanchHomePage, canActivate: [AuthGuard]},
      {
        path: 'admin',
        loadChildren: () => import('./pages/admin/admin.module').then(m => m.AdminModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'settings',
        loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'livestock',
        loadChildren: () => import('./pages/livestock/livestock.module').then(m => m.LivestockModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'mapping',
        loadChildren: () => import('./pages/mapping/mapping.module').then(m => m.MappingModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'finance',
        loadChildren: () => import('./pages/finance/finance.module').then(m => m.FinanceModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'tasks',
        loadChildren: () => import('./pages/task/task.module').then(m => m.TaskModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'lrp',
        loadChildren: () => import('./pages/lrp/lrp.module').then(m => m.LRPModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'lease',
        loadChildren: () => import('./pages/lease/lease.module').then(m => m.LeaseModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'asset-monitoring',
        loadChildren: () => import('./pages/asset-monitoring/asset-monitoring.module').then(m => m.AssetMonitoringModule),
        canActivate: [AuthGuard]
      },

      // { path: 'agreement', component: AgreementAcceptPage },
      // { path: 'updateuser', component: UpdateUserPage },
      // { path: 'gaugedetails', loadChildren: './pages/gauge-details/gauge-details.module#GaugeDetailsPageModule' },
      {path: 'prf', loadChildren: () => import('./pages/prf/hargrove/hargrove.module').then(m => m.HargroveModule)},
      {path: 'advanced-prf', loadChildren: () => import('./pages/prf/aap/aap.module').then(m => m.AapModule)},

      // {
      //   path: 'water-monitoring', loadChildren: './pages/water-monitoring/water-monitoring.module#WaterMonitoringPageModule'
      // },
      {path: 'support', loadChildren: () => import('./pages/support/support.module').then(m => m.SupportModule)},
      // { path: 'dev', loadChildren: './pages/dev/dev.module#DevPageModule' },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
